import {
  LeadEventsApi,
  type LeadEventLifecycleStatus,
  type LeadEventWithStatusDto,
} from '@up2stay/up2promo-api-client';

import {
  LIST_FETCH_ALL_MAX_PAGES,
  LIST_PAGE_HARD_CAP,
} from '@/core/lib/list-pagination';

/** Matches backend `LIST_PAGE_HARD_CAP` / `clampListLimit`. */
export const LEAD_EVENTS_LIST_PAGE_LIMIT = LIST_PAGE_HARD_CAP;

/**
 * Loads every workspace lead-event by paging `LeadEventsApi.findAll` until a
 * partial page. Required because the API hard-caps `limit` at 100.
 */
export async function fetchAllLeadEventsPages(
  workspaceId: string,
  options?: { status?: LeadEventLifecycleStatus },
): Promise<LeadEventWithStatusDto[]> {
  const byId = new Map<string, LeadEventWithStatusDto>();

  for (let page = 0; page < LIST_FETCH_ALL_MAX_PAGES; page += 1) {
    const skip = page * LEAD_EVENTS_LIST_PAGE_LIMIT;
    const response = await LeadEventsApi.findAll({
      path: { workspaceId },
      query: {
        ...(options?.status ? { status: options.status } : {}),
        limit: LEAD_EVENTS_LIST_PAGE_LIMIT,
        skip,
      },
    });

    const batch = response.data ?? [];
    for (const event of batch) {
      if (event.id) byId.set(event.id, event);
    }
    if (batch.length === 0 || batch.length < LEAD_EVENTS_LIST_PAGE_LIMIT) {
      break;
    }
  }

  return [...byId.values()];
}
